import { HttpClient } from "../httpClient";

const httpClient = new HttpClient();

const contactUs  = (data: any) => {
    return httpClient.post(`Contactus/contactus`, data);
}


const contactUsService = {
    contactUs,
};

export default contactUsService;